import { db } from "@/firebaseApp";
import { collection, onSnapshot, } from "firebase/firestore";

const links = {
    namespaced: true,
    state: {
        all: [],
        projectId: null,
        unsub: null,
    },

    getters: {
        messageID: (state) => (messageId) => {
            return state.all.find(({ id }) => id == messageId)
        },
        sorted(state) {
            return [...state.all].sort((a, b) => {
                if (a.createdAt == null) return 1
                if (b.createdAt == null) return -1
                return a.createdAt - b.createdAt
            })
        },
        lastMessage(state) {
            const message = state.all.map(m => m.messageSent)

            return message.slice(-1)[0]
        },
    },

    mutations: {
        add(state, message) {
            state.all.push(message);
        },
        edit(state, message) {
            const index = state.all.findIndex((m) => message.id == m.id)
            state.all.splice(index, 1, message)
        },
        delete(state, id) {
            const index = state.all.findIndex((message) => message.id == id)
            state.all.splice(index, 1)
        },
        reset(state) {
            state.messagesUnsub()
            state.messagesUnsub = null
            state.all = []
        },
        sub(state, { unsub, projectId }) {
            state.unsub = unsub
            state.projectId = projectId
            state.all = []
        },
        unsub(state) {
            if (state.unsub == null) {
                return
            }
            state.unsub()
            state.projectId = null
        },
    },

    actions: {
        async getAll({ commit, rootState }, projectId) {
            const instanceId = rootState.instanceId
            const currentUser = rootState.users.currentUser
            if (instanceId == null) return
            if (currentUser == null) return

            commit('unsub')

            try {
                // const messageRef = collection(db, `instances/${instanceId}/messages`)
                const messageRef = collection(db, `instances/${instanceId}/projects/${projectId}/links`)
                const unsub = onSnapshot(messageRef, (querySnapshot) => {
                    querySnapshot.docChanges().forEach(async (change) => {
                        const doc = change.doc
                        const message = { ...doc.data(), id: doc.id }
                        if (change.type === "added") {
                            commit("add", message);
                        }
                        if (change.type === "modified") {
                            commit("edit", message);
                        }
                        if (change.type === "removed") {
                            commit("delete", doc.id);
                        }
                    });
                })
                commit("sub", { unsub, projectId })
            } catch (error) {
                console.log("ERROR TO GET ALL MESSAGES: " + error);
            }
        },
    },
};

export default links;
